import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { makeGetPublicContact } from '../reduxes/slices/public_contacts/selectors'
import { getApiPublicContacts } from '../reduxes/slices/api/selectors'
import { useSelectorDelegateStore } from '../reduxes/stores/root_store/hooks'

export const useGetPublicContact = (handle?: string) => {
  const getPublicContactFromRootStore = useMemo(makeGetPublicContact, [])
  const publicContactFromRootStore = useSelectorDelegateStore((state) =>
    // eslint-disable-next-line
    // @ts-ignore
    getPublicContactFromRootStore(state, { handle }),
  )
  const getPublicContactFromStore = useMemo(makeGetPublicContact, [])
  const publicContactFromStore = useSelector((state) =>
    // eslint-disable-next-line
    // @ts-ignore
    getPublicContactFromStore(state, { handle }),
  )

  return useMemo(() => {
    if (publicContactFromRootStore && publicContactFromStore) {
      return Date.parse(publicContactFromRootStore.updated_at) >=
      Date.parse(publicContactFromStore.updated_at)
        ? publicContactFromRootStore
        : publicContactFromStore
    } else {
      return publicContactFromRootStore || publicContactFromStore
    }
  }, [publicContactFromRootStore, publicContactFromStore])
}

export const useGetPublicContacts = (handles: string[]) => {
  const x = useSelectorDelegateStore(getApiPublicContacts)
  const y = useSelector(getApiPublicContacts)

  const rootStorePublicContacts: any = useMemo(() => {
    return indexByHandle(x)
  }, [x])

  const subStorePublicContacts: any = useMemo(() => {
    return indexByHandle(y)
  }, [y])

  return useMemo(() => {
    return handles.reduce((acc: any, handle) => {
      const rootStorePublicContact = rootStorePublicContacts[handle]
      const subStorePublicContact = subStorePublicContacts[handle]
      if (rootStorePublicContact && subStorePublicContact) {
        acc.push(
          Date.parse(rootStorePublicContact.updated_at) >=
          Date.parse(x.updated_at)
            ? rootStorePublicContact
            : subStorePublicContact,
        )
      } else {
        if (rootStorePublicContact || subStorePublicContact) {
          acc.push(rootStorePublicContact || subStorePublicContact)
        }
      }
      return acc
    }, [])
  }, [handles, rootStorePublicContacts, subStorePublicContacts, x.updated_at])
}

const indexByHandle = (publicContacts: any) => {
  return Object.values(publicContacts).reduce(
    (acc: any, publicContact: any) => {
      acc[publicContact.handle] = publicContact
      return acc
    },
    {},
  )
}
